import PropTypes from 'prop-types';
import {Paper, Box, Typography, Button} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

function DownloadCard({onSelect}) {
    return (
        <Paper
            elevation={0}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                overflow: 'auto',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                border: '1px solid #e0e0e0',
                borderRadius: 1,
                bgcolor: '#fff',
                p: 2,
            }}
        >
            <DownloadIcon sx={{ fontSize: 48, mb: 2, color: '#155FA7' }} />

            <Typography variant="h6" gutterBottom>
                Download detailed learner, staff and school data
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Choose your preferred format and the report will be generated using the filters you&apos;ve set.
            </Typography>

            <Box sx={{ display: 'flex', gap: 2 }}>
                <Button
                    sx={{
                        backgroundColor: '#186BBE',
                        boxShadow: 'none',
                        width: { xs: '100%', sm: 'auto' },
                        '&:hover': {
                            backgroundColor: '#155FA7',
                            boxShadow: 'none'
                        }
                    }}
                    variant="contained"
                    onClick={() => onSelect('csv')}
                    startIcon={<DownloadIcon />}
                >
                    CSV
                </Button>
                <Button
                    sx={{
                        color: '#186BBE',
                        boxShadow: 'none',
                        width: {xs: '100%', sm: 'auto'},
                        borderColor: '#186BBE'

                    }}
                    variant="outlined"
                    onClick={() => onSelect('xlsx')}
                    startIcon={<DownloadIcon />}
                >
                    XLSX
                </Button>
            </Box>
        </Paper>
    );
}

DownloadCard.propTypes = {
    onSelect: PropTypes.func.isRequired,
};

export default DownloadCard;
